import React from 'react'
import ReportWrapper from '../ReportWrapper'
import ReportSectionHeading from '../ReportSectionHeading'
import { Stack, Table, Text } from '@mantine/core'
import { useTheme } from '../../../components/ThemeProvider'

interface HolderItem {
  name: string
  alias: string
  capital: Array<{
    amomon: string
    paymet: string
    time: string
    percent: string
  }>
}

interface TianyanchaHolderProps {
  data: any
  title: string
  sectionIndex?: string
}

const HoldersTable = ({ holders }: { holders: HolderItem[] }) => {
  return (
    <Table
      highlightOnHover
      verticalSpacing="sm"
      withColumnBorders={false}
      styles={{
        table: { fontSize: '13px', tableLayout: 'fixed' },
        th: { whiteSpace: 'nowrap' },
      }}
    >
      <Table.Thead>
        <Table.Tr>
          <Table.Th style={{ width: '30%' }}>股东名称</Table.Th>
          <Table.Th style={{ width: '25%' }}>认缴出资</Table.Th>
          <Table.Th style={{ width: '25%' }}>出资比例</Table.Th>
          <Table.Th style={{ width: '20%' }}>认缴时间</Table.Th>
        </Table.Tr>
      </Table.Thead>
      <Table.Tbody>
        {holders.map((holder) => {
          const capitalInfo = holder.capital?.[0]
          return (
            <Table.Tr key={holder.name}>
              <Table.Td>{holder.name || '—'}</Table.Td>
              <Table.Td>{capitalInfo?.amomon || '—'}</Table.Td>
              <Table.Td>{capitalInfo?.percent || '—'}</Table.Td>
              <Table.Td>{capitalInfo?.time || '—'}</Table.Td>
            </Table.Tr>
          )
        })}
      </Table.Tbody>
    </Table>
  )
}

export default function TianyanchaHolder({ data, title, sectionIndex }: TianyanchaHolderProps) {
  let jsonData: any
  try {
    jsonData = JSON.parse(data.tianyancha_holder ?? '{}')
  } catch (error) {
    jsonData = {}
  }
  const holders: HolderItem[] = jsonData.items || []
  const theme = useTheme()

  return (
    <ReportWrapper>
      <ReportSectionHeading title={title} index={sectionIndex} />
      {holders.length === 0 ? (
        <Text c="dimmed" size="sm" ta="center" className="mt-2">
          暂无股东信息
        </Text>
      ) : (
        <div className="mt-2">
          <Text size="sm" fw={600} style={{ color: theme.accentTextColor }}>
            股东信息
          </Text>
          <Stack gap="sm" className="mt-3">
            <HoldersTable holders={holders} />
          </Stack>
        </div>
      )}
    </ReportWrapper>
  )
}
